import { render, staticRenderFns } from "./detail-dialog.vue?vue&type=template&id=1b48bf9e&scoped=true&"
import script from "./detail-dialog.vue?vue&type=script&lang=ts&"
export * from "./detail-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./detail-dialog.vue?vue&type=style&index=0&id=1b48bf9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b48bf9e",
  null
  
)

component.options.__file = "detail-dialog.vue"
export default component.exports